import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Image from 'gatsby-image'
import { Row, Col } from 'reactstrap'
import { prop } from 'ramda'
import { Placeholder } from '../../GlobalStyles'

export const BackgroundFooter = () => {
  const data = useStaticQuery(graphql`
    query {
      Image1: file(name: { eq: "image32" }) {
        childCloudinaryAsset {
          fluid {
            ...CloudinaryAssetFluid
          }
        }
      }
      Image2: file(name: { eq: "image33" }) {
        childCloudinaryAsset {
          fluid {
            ...CloudinaryAssetFluid
          }
        }
      }
    }
  `)
  return (
    <>
      <Row noGutters>
        <Col xs='12' md='6'>
          {prop('Image1', data) ? (
            <Image fluid={data.Image1.childCloudinaryAsset.fluid} />
          ) : (
            <Placeholder />
          )}
        </Col>
        <Col xs='12' md='6'>
          {prop('Image2', data) ? (
            <Image fluid={data.Image2.childCloudinaryAsset.fluid} />
          ) : (
            <Placeholder />
          )}
        </Col>
      </Row>
    </>
  )
}

export default BackgroundFooter
